module.exports = __webpack_public_path__ + "static/media/tagline.3eb7679e.svg";